import PodcastEpisode from './PodcastEpisode';
import Podcast from './Podcast';
import { isEmpty } from 'util/index';
import { UniversalConfig, UniversalClipCollection, UniversalClip } from '../interfaces';
import { TILE_SIZES } from 'globalConst/const';
import { DisplayLayout } from 'components/Collection/Collection.const';
import SHOW_MORE from '../../globalConst/searchResults-const';
import CollectionPagination from './CollectionPagination';

// interface UniversalClipCollection extends UniversalCollection {
//   items: UniversalPodcast[];
// }

/**
 * @class
 * A representation of a PodcastCollection
 *
 * @param {object} collection - collection model
 */
export default class SearchClipCollection extends CollectionPagination {
  tileSizes: string = TILE_SIZES.SMALL;
  items: Array<PodcastEpisode>;
  display = DisplayLayout.LIST;
  rows = SHOW_MORE.PODCASTS.DEFAULT_EPISODE_LIMIT;
  isPodcastPage = true;

  constructor(collection: UniversalClipCollection, config: UniversalConfig[], options: string[]) {
    super(collection, config, options);

    if (isEmpty(collection)) {
      return null;
    }

    const searchClipCollection = <UniversalClipCollection>collection;

    this.tileSizes = TILE_SIZES.SMALL;
    this.items =
      searchClipCollection.getClips.clips &&
      searchClipCollection.getClips.clips.map((item: UniversalClip) => {
        const podcast = new Podcast(item.reference);
        return new PodcastEpisode({ ...item, podcastTitle: podcast.title, subTitle: item.title }, podcast);
      });
    this.nextToken = searchClipCollection.getClips.nextToken;
    this.totalCount = searchClipCollection.getClips.totalCount;
    // Make this class read-only
    Object.freeze(this);
  }
}
